import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../utils/axiosInstance';

export const fetchAdminBlogs = createAsyncThunk('blogs/fetchAdmin', async ({page = 1, limit = 10}, { rejectWithValue })=>{
	try{
		let url = window.location.href
		let link = url.includes('?') ? `?${url.split("?")[1]}&page=${page}&limit=${limit}` : `?&page=${page}&limit=${limit}`
		const { data } = await axiosInstance.get(`/admin/blogs/admin-fetch${link}`);
		return data;
	}catch(e){ return rejectWithValue(e.response?.data || e.message); }
});

export const createBlog = createAsyncThunk('blogs/create', async (payload, { rejectWithValue })=>{
	try{
		const { data } = await axiosInstance.post('/admin/blogs', payload);
		return data.blog;
	}catch(e){ return rejectWithValue(e.response?.data || e.message); }
});

export const updateBlog = createAsyncThunk('blogs/update', async ({ id, updates }, { rejectWithValue })=>{
	try{
		const { data } = await axiosInstance.put(`/admin/blogs/${id}`, updates);
		return data.blog;
	}catch(e){ return rejectWithValue(e.response?.data || e.message); }
});

export const deleteBlog = createAsyncThunk('blogs/delete', async (id, { rejectWithValue })=>{
	try{
		await axiosInstance.delete(`/admin/blogs/${id}`);
		return id;
	}catch(e){ return rejectWithValue(e.response?.data || e.message); }
});

export const fetchBlogById = createAsyncThunk('blogs/fetchById', async (id, { rejectWithValue }) => {
	try {
		const { data } = await axiosInstance.get(`/admin/blogs/fetch-id/${id}`); // adjust if your show route differs
		return data;
	} catch (e) {
		return rejectWithValue(e.response?.data || e.message);
	}
});

const slice = createSlice({
	name: 'blogs',
	initialState:{
		isLoading: false,
		message: null,
		error:null,
		singleBlog: null,
		blogs:[],
		pagination:{
			total: 0,
			page: 1,
			limit: 10,
			totalPages: 1
		},
	},
	reducers:{
		clearSingleBlog: (state, action) => {
			state.singleBlog = null;
		},
	},
	extraReducers: b=>{
		b.addCase(fetchAdminBlogs.pending, s=>{ s.isLoading=true; s.error=null; })
		.addCase(fetchAdminBlogs.rejected, s=>{ s.isLoading=false; s.error=null; })
		.addCase(fetchAdminBlogs.fulfilled,(s,a)=>{
			s.isLoading = false;
			s.blogs = a.payload.blogs;
			s.pagination = a.payload.pagination;
		})
		.addCase(createBlog.pending, s=>{ s.saving=true; })
		.addCase(createBlog.fulfilled,(s,a)=>{ s.saving=false; s.blogs.unshift(a.payload); })
		.addCase(createBlog.rejected,(s,a)=>{ s.saving=false; s.error=a.payload; })
		.addCase(fetchBlogById.fulfilled, (s,a)=>{
			s.singleBlog = a.payload.blog;
		});
	}
});
export const{clearSingleBlog} = slice.actions;
export default slice.reducer;